import { useContext, useState } from "react";
import { Helmet } from "react-helmet";
import toast from "react-hot-toast";

import { LabourerContext } from "../contexts/LabourerContext";

import EmployeeAllocationList from "./EmployeeAllocationList";
import RequestLeaveForm from "./RequestLeaveForm";
import LabourerNotificationTable from "./LabourerNotificationTable";
import LabourerProjectView from "./LabourerProjectView";
import Modal from "./Modal";

import leaveRequestService from "../services/leaveRequestService";
import useBroadcast from "../hooks/useBroadcast";
import SectionHeader from "./SectionHeader";

const Dashboard = () => {
  const { labourer } = useContext(LabourerContext);

  const [selectedProject, setSelectedProject] = useState(null);

  const [isProjectViewOpen, setIsProjectViewOpen] = useState(false);
  const [isRequestLeaveModalOpen, setIsRequestLeaveModalOpen] = useState(false);

  const { data: broadcast } = useBroadcast();

  const handleAllocationClicked = (allocation) => {
    console.log('Allocation clicked:', allocation);
    setSelectedProject(allocation.project);
    setIsProjectViewOpen(true);
  }

  const handleLeaveRequestSubmit = async (payload) => {
    try {
      await leaveRequestService.createLeaveRequest({
        labourer: labourer._id,
        ...payload
      });

      setIsRequestLeaveModalOpen(false);
      toast.success('Leave request submitted', { icon: '🎉' });
    } catch (error) {
      console.error(error);
      toast.error('Failed to submit leave request. Please try again', { icon: '❌' });
    }
  }

  return (
    <>
      <Helmet>
        <title>Dashboard | ASE Group</title>
      </Helmet>

      <div className="flex flex-col">
        {broadcast && (
          <div className="mb-4 md:mb-8 rounded-lg border border-gray-300 self-center shadow-md md:min-w-[600px] w-full">

            <SectionHeader
              title="Broadcast"
              centeredTitle={true}
            />

            <div className="py-2 px-4 text-center" dangerouslySetInnerHTML={{ __html: broadcast?.content }}></div>
          </div>
        )}

        <div className="flex flex-col">
          <div className="flex flex-col md:flex-row justify-between gap-4 md:gap-[2%]">
            <div className="w-full md:w-[60%] flex-grow">
              <EmployeeAllocationList
                onAllocationClicked={handleAllocationClicked}
                onRequestLeaveClicked={e => setIsRequestLeaveModalOpen(true)}
              />
            </div>

            <div className="border-ase-blue border rounded-lg w-full md:w-[40%] flex-grow pb-1 h-fit">
              <SectionHeader title="Notifications" />

              <LabourerNotificationTable />
            </div>
          </div>
        </div>
      </div>

      <Modal isOpen={isProjectViewOpen}>
        <LabourerProjectView
          project={selectedProject}
          onCloseClicked={() => setIsProjectViewOpen(false)}
        />
      </Modal>

      <Modal isOpen={isRequestLeaveModalOpen}>
        <RequestLeaveForm
          onSubmit={handleLeaveRequestSubmit}
          onCloseClicked={e => setIsRequestLeaveModalOpen(false)}
        />
      </Modal>
    </>
  )
}

export default Dashboard;
